angular.module("kitstajm").factory("Trello", function ($resource) {
  return $resource(
    "api/trello/:kpi",
    { kpi: "@kpi" },
    {
      get: { method: "GET", isArray: true },
    }
  );
});
